import { Outlet } from "react-router-dom";
import TrueSourceDisclaimer from "../components/common/true-source-disclaimer";

const InfoLayout = () => (
    <>
        <Outlet />
        <TrueSourceDisclaimer />
    </>
);

export default InfoLayout;